<script>
  import { Card } from 'element-ui'
  export default {
    name:'ElCard',
    extends:Card
  }
</script>
